export default {
      id: "icon-videoplay-usage",
      viewBox: "0 0 36 24",
      url: __webpack_public_path__ + "icons.svg#icon-videoplay",
      toString: function () {
        return this.url;
      }
    }